import React, { ChangeEvent, Ref, forwardRef } from 'react';

import { Flex, Input } from 'src/packages/core';
import { CalendarIcon, XIcon } from 'src/packages/icons';

import { CustomInputProps, DateRangeValuesDelimiter } from '../DateRange.types';

const DATE_RANGE_REGEX = `/^(\\d{4}-\\d{2}-\\d{2})\\s*${DateRangeValuesDelimiter}\\s*(\\d{4}-\\d{2}-\\d{2})$/`;

export const CustomInput = forwardRef(
  (
    {
      value,
      className,
      isClearable,
      defaulttheme,
      onClick,
      onChange,
      handleChange,
      ...rest
    }: CustomInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    value = value && value.toString().replace(' - ', ` ${DateRangeValuesDelimiter} `);

    //change input value
    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      if (onChange) {
        onChange(e);
      }
      //if match regex change date range
      if (val.match(DATE_RANGE_REGEX)) {
        const [startDate, endDate] = val.split(` ${DateRangeValuesDelimiter} `);
        handleChange([new Date(startDate), new Date(endDate)]);
      }
    };

    //clear value of input
    const handleClear = () => {
      handleChange([null, null]);
    };

    return (
      <Input
        ref={ref}
        value={value}
        className={`${className}, date-ranger-picker-input`}
        onClick={onClick}
        rightElement={
          isClearable && value ? (
            <Flex onClick={handleClear}>
              <XIcon color={defaulttheme.colors.text.primary} size={16} />
            </Flex>
          ) : (
            <CalendarIcon color={defaulttheme.colors.text.primary} size={16} />
          )
        }
        {...rest}
        onChange={handleInputChange}
      />
    );
  }
);
